import { createFileRoute, redirect } from '@tanstack/react-router';
import { db, ensureDefaults } from '@/lib/db';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    let book = 'GEN';
    let chapter = 1;
    try {
      const prefs = (await db.prefs.get('singleton')) ?? (await ensureDefaults());
      book = prefs.lastReadBook ?? 'GEN';
      chapter = prefs.lastReadChapter ?? 1;
    } catch {
      // IndexedDB unavailable (private mode, restricted WebView): use defaults.
    }
    throw redirect({ to: '/read/$book/$chapter', params: { book, chapter: String(chapter) } });
  },
});
